import { useMemo } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { OwnerType } from "@/domains/inventory/constants/ownerType";
import { IS_DEV } from "@/domains/main/constants/other";
import { inventoryMapSelector } from "@/domains/inventory/slice";
import { playerInfoSelector } from "@/domains/player/slice";
import { sortInventories } from "@/domains/inventory/helpers/sortedInventories";
import InventoryAddItem from "@/domains/inventory/containers/InventoryAddItem";
import InventoryDndContextWrapperContainer from "@/domains/inventory/containers/InventoryDndContextWrapperContainer";
import InventorySearchBagContainer from "@/domains/inventory/containers/search/InventorySearchBagContainer";
import InventorySearchConfiscationContainer from "@/domains/inventory/containers/search/InventorySearchConfiscationContainer";
import InventorySearchContainer from "@/domains/inventory/containers/search/InventorySearchContainer";

type Props = {
  isOpen: boolean;
};

export default function SearchContainer({ isOpen }: Props) {
  const playerInfo = useAppSelector(playerInfoSelector);
  const inventoryMap = useAppSelector(inventoryMapSelector);

  const sortedInventories = useMemo(() => sortInventories(inventoryMap), [inventoryMap]);

  if (!isOpen || !playerInfo) return null;

  return (
    <InventoryDndContextWrapperContainer>
      <div className="fixed inset-0 px-[--boundary-offset-x] py-[--boundary-offset-y] flex items-end justify-end gap-5 z-[9999]">
        {IS_DEV && <InventoryAddItem />}
        {sortedInventories.map(([key, inventory]) => {
          switch (inventory.ownerType) {
            case OwnerType.Bag:
              return <InventorySearchBagContainer key={key} inventoryId={inventory.id} />;
            case OwnerType.Character:
              return <InventorySearchContainer key={key} inventoryId={inventory.id} />;
            case OwnerType.Confiscation:
              return <InventorySearchConfiscationContainer key={key} inventoryId={inventory.id} />;
            default:
              return null;
          }
        })}
      </div>
    </InventoryDndContextWrapperContainer>
  );
}
